// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609021024/js/" + chunkId + "." + {"44":"48d63752","225":"d3638458","481":"85e89252","486":"ab38a125","770":"9e7483ab"}[chunkId] + ".0.42953724949155214.chunk.js";
};